import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import companyReducer from '../slice/companySlice'
import departmentReducer from '../slice/departmentSlice'

export const store = configureStore({
  reducer: {
    company: companyReducer,
    department: departmentReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
